<template>
  <div>
      <div >
          <label for="id_test">Send Test emails to yourself?</label>
          <input type="checkbox" v-model="smtp.test"
                                                                    id="id_test"/>
          <button class='btn btn-primary'
                  value='send'
                  v-on:click="send()">
            <i class="fa fa-spin fa-spinner" v-if="sending"></i>
            <span v-if="smtp.test">Send Test</span><span v-else>Send to recipients</span>
        </button>
      </div>
   </div>
</template>

<script>
  import Info from './Info';

  export default {
    components: {
      info: Info,
    },
    props: ['errors', 'numAvailable', 'sending', 'email'],
    data() {
      return {
        smtp: {
          username: this.email,
          test: true,
        },
      };
    },
    methods: {
      send() {
        this.$emit('sendemail', this.smtp);
      },
    },
  };
</script>


// WEBPACK FOOTER //
// SmtpInfo.vue?0d22c632